package com.nonopn.skydome.common.app.navigation

// Pure helpers for the paths of the administrator routes (kept free of any UI dependency for unit tests).

private const val AdminEstimatePrefix = "/admin/estimate/"

/**
 * Uuid of the estimate in "/admin/estimate/<uuid>" (a trailing slash, a query string or a fragment are ignored).
 * Returns an empty string when the path has no uuid.
 */
fun estimateUuidFromAdminPath(path: String): String = path
    .substringBefore('?')
    .substringBefore('#')
    .trimEnd('/')
    .removePrefix(AdminEstimatePrefix.trimEnd('/'))
    .trim('/')
    .substringBefore('/')
